import { Avatar, Box, Card, Chip, Typography } from "@mui/material";
import { Email, WorkOutline } from "@mui/icons-material";
import "./profileHeader.css";

const formatRole = (role) => {
  const roles = Array.isArray(role) ? role : role ? [role] : [];
  return roles
    .map((r) => r.replace("ROLE_", "").replace(/_/g, " "))
    .join(", ");
};

const getUserInitials = (user) => {
  const firstInitial = user?.firstname ? user.firstname[0].toUpperCase() : "";
  const lastInitial = user?.lastname ? user.lastname[0].toUpperCase() : "";
  return `${firstInitial}${lastInitial}`.trim();
};

const ProfileHeader = ({ user, email, fonction, isActive, imageUrl }) => {
  return (
    <Card className="profileHeaderCard" elevation={0}>
      <Box className="profileHeaderRow">
        <Avatar variant="rounded" className="profileHeaderAvatar">
          {!imageUrl ? getUserInitials(user) : <img alt="avatar" width="100%" src={imageUrl} />}
        </Avatar>

        <Box className="profileHeaderIdentity">
          <Typography className="profileHeaderName">
            {user?.titre ? `${user.titre} ` : ""}
            {user?.lastname} {user?.firstname}
          </Typography>
          <Box className="profileHeaderMetaRow">
            <Box className="profileHeaderMetaItem">
              <Email className="profileHeaderMetaIcon" />
              <Typography className="profileHeaderMetaText">{email}</Typography>
            </Box>
            <Box className="profileHeaderMetaItem">
              <WorkOutline className="profileHeaderMetaIcon" />
              <Typography className="profileHeaderMetaText">{fonction || formatRole(user?.role)}</Typography>
            </Box>
          </Box>
        </Box>

        <Box>
          <Chip
            label={isActive === false ? "INACTIF" : "ACTIF"}
            size="small"
            className={isActive === false ? "profileHeaderBadgeInactive" : "profileHeaderBadgeActive"}
          />
        </Box>
      </Box>
    </Card>
  );
};

export default ProfileHeader;
